module.exports = __webpack_public_path__ + "media/images/fallback/figures/default_article_image_3-01f50f5b1aed89709eda61a334abe083.png";